/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function r(r,e){const n=Number(r),t=(new Intl.NumberFormat).format(n),m=new Intl.NumberFormat("en-US",{style:"currency",currency:"USD"}).format(n);return e?m:t}export{r as formatDigits};
//# sourceMappingURL=formatDigits.js.map
